require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-107-percentage-complete-calculated.json") })
        }
      }, "path---article-107-percentage-complete-calculated");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-107-percentage-complete-calculated!./.cache/json/article-107-percentage-complete-calculated.json
// module id = 468
// module chunks = 231608221292675